import styled from "@emotion/styled";

export const MessageContainer = styled.div`
  width: 100%;
  padding: 1rem 0;
  margin-bottom: 1rem;
  background-color: transparent;
  display: grid;
  grid-template-columns: 1fr;

  .message-feedback-actions-container {
    opacity: 0;
    transition: 200ms;
  }
  &:hover {
    .message-feedback-actions-container {
      opacity: 1;
    }
  }
`;

export const MessageContent = styled.div`
  overflow-x: auto;
`;

const MessageText = styled.div`
  color: ${(p) => p.theme.text.colors.primary};
  font-size: ${(p) => p.theme.text.fontSizes.l};
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  position: relative;
  max-width: 90%;

  ${(p) => p.theme.media.mobileDown} {
    font-size: ${(p) => p.theme.text.fontSizes.l};
    max-width: calc(100% - 2.5rem);
  }

  p,
  li,
  span {
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }

  a {
    word-break: break-all;
    color: ${(p) => p.theme.link.colors.primary};
    text-decoration: none;

    &:hover {
      color: ${(p) => p.theme.link.colors.hover};
    }
  }

  img {
    max-width: clamp(200px, 85%, 480px);
    width: 100%;
    display: block;
    margin-bottom: 0.75rem;
    max-height: 360px;
    object-fit: cover;
    object-position: center;
    ${(p) => p.theme.media.mobileDown} {
      max-width: 90%;
    }
  }

  p:not(:last-child) {
    margin-bottom: 1rem;
  }

  ol,
  ul {
    padding-left: 0;
    margin-bottom: 1.5rem;
    margin-inline-start: 2rem;

    ${(p) => p.theme.media.mobileDown} {
      margin-inline-start: 1.5rem;
    }
  }

  li {
    margin-top: 0.25rem;

    img {
      padding-top: 0.5rem;
    }
  }

  code {
    background-color: ${(p) => p.theme.colors.background2} !important;
    padding: 0.25rem 0.375rem;
    border-radius: 0.25rem;
    white-space: pre-wrap;
    word-break: break-word;
  }

  h3 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(p) => p.theme.text.fonts.primary};
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  /* JSON TEXT EDITOR */
  pre {
    margin: 0 !important;
    margin-bottom: 1rem !important;
    border-radius: 0.5rem !important;
    overflow: hidden;

    code {
      background-color: ${(p) => p.theme.jsonText.colors.background} !important;
    }

    & > div {
      background-color: ${(p) => p.theme.jsonText.colors.background} !important;
      max-width: 100% !important;
      border-radius: 0.5rem !important;
      font-size: ${(p) => p.theme.text.fontSizes.m} !important;
      overflow-x: auto !important;
      margin: 0 !important;
      padding: 1.5rem !important;
      max-height: 400px !important;

      * {
        white-space: pre-wrap;
        word-break: break-word;
      }
    }
  }

  pre > code {
    background-color: ${(p) => p.theme.colors.background} !important;
    font-size: ${(p) => p.theme.text.fontSizes.m} !important;
  }
`;

// User Message
export const UserMessageContainer = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;

  ${(p) => p.theme.media.mobileDown} {
    padding: 0.5rem;
  }
`;

export const BotMessageText = styled(MessageText)`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

export const UserMessageText = styled(MessageText)`
  background-color: ${(p) => p.theme.colors.background2};
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
  justify-self: flex-end;
`;

export const WidgetArtifactsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
